export default "__VITE_ASSET__DbD67oka__"